import React, { useEffect, useState } from "react";

export function BoardGame(props: { view: string }) {
  type Cell = {
    value: string;
    row: number;
    col: number;
  };

  const board = [
    ["XD", "~.~", "O.o", ":D"],
    ["~.~", "XD", ":D", "O.o"],
  ];

  const [previousCell, setPreviousCell] = useState<Cell>({
    value: "",
    row: -1,
    col: -1,
  });

  const [revealedBoard, setrevealedBoard] = useState([
    ["", "", "", ""],
    ["", "", "", ""],
  ]);

  const [gameOver, setGameOver] = useState(false);

  const [showGame, setShowGame] = useState(false);

  const handleShowingGame = () => {
    // toggle the game
    let game = document.querySelector<HTMLElement>(".BoardGame");
    !showGame
      ? (game!.style.animation = "fadeGameIn 1.5s forwards")
      : (game!.style.animation = "fadeGameOut 1.5s forwards");
    setShowGame((showGame) => !showGame);
  };

  const handleCellClick = (i: number, j: number) => {
    // set the cell to be revealed
    const newRevealedBoard = [...revealedBoard];
    let clickedCell: Cell;
    clickedCell = { value: board[i][j], row: i, col: j };

    // first click
    if (previousCell.value === "") {
      setPreviousCell(clickedCell);
      newRevealedBoard[i][j] = board[i][j];
    } else {
      // second click
      if (previousCell.value === clickedCell.value) {
        // reveal the current cell
        newRevealedBoard[i][j] = board[i][j];
        setPreviousCell({ value: "", row: -1, col: -1 });
        handleSuccess();
      } else {
        // show the cell for a second and then hide it
        newRevealedBoard[i][j] = board[i][j];
        setrevealedBoard([...newRevealedBoard]);

        handleFail(newRevealedBoard, i, j, previousCell);
      }
    }

    setrevealedBoard([...newRevealedBoard]);
    displayWinningMessage(newRevealedBoard);
  };

  let disableAllCells = () => {
    const cells = document.querySelectorAll<HTMLElement>(".cell");
    const container = document.querySelectorAll<HTMLElement>(".cellContainer");
    container.forEach((container) => {
      container.style.cursor = "not-allowed";
    });
    cells.forEach((cell) => {
      cell.style.pointerEvents = "none";
    });
  };

  let activateAllCells = () => {
    const cells = document.querySelectorAll<HTMLElement>(".cell");
    const container = document.querySelectorAll<HTMLElement>(".cellContainer");
    container.forEach((container) => {
      container.style.cursor = "pointer";
    });
    cells.forEach((cell) => {
      cell.style.pointerEvents = "auto";
    });
  };

  /**
   * The function handles a success animation by changing the background color of an element and
   * resetting it after a certain time.
   */
  let handleSuccess = () => {
    const pengu = document.querySelector<HTMLElement>(".pengu");
    const container = document.querySelector<HTMLElement>(".container");
    disableAllCells();

    container!.style.animation = "success 1s linear";
    pengu!.style.backgroundColor = "green";

    setTimeout(() => {
      container!.style.animation = "";
      pengu!.style.backgroundColor = "";
      activateAllCells();
    }, 1300);
  };

  /**
   * The function handles a fail scenario in a memory game by resetting the revealed board and previous
   * cell, and changing the background color of a penguin element.
   * @param {string[][]} newRevealedBoard - a 2D array of strings representing the current state of the
   * game board with some cells revealed
   * @param {number} i - The row index of the cell that failed to match with the previous cell.
   * @param {number} j - j is a number representing the column index of a cell in a 2D array.
   * @param setrevealedBoard - A React hook function that sets the state of the revealed board in the
   * component. It takes in a new 2D array of strings as an argument and updates the state of the
   * revealed board with it.
   * @param previousCell - An object that contains the value, row, and column of the previously clicked
   * cell on the game board. It is used to reset the values of both the current and previous cells if the
   * current cell does not match the previous cell.
   * @param setPreviousCell - A React state setter function for updating the previous cell value and
   * position.
   */
  let handleFail = (
    newRevealedBoard: string[][],
    i: number,
    j: number,
    previousCell: { value: string; row: number; col: number }
  ) => {
    const pengu = document.querySelector<HTMLElement>(".pengu");
    pengu!.style.backgroundColor = "rgb(201, 42, 42)";
    disableAllCells();

    setTimeout(() => {
      newRevealedBoard[i][j] = "";
      setrevealedBoard([...newRevealedBoard]);
      newRevealedBoard[previousCell.row][previousCell.col] = "";
      setPreviousCell({ value: "", row: -1, col: -1 });
      pengu!.style.backgroundColor = "";
      activateAllCells();
    }, 700);
  };

  /**
   * The function checks if all cells in a game board are revealed and displays a message to restart the
   * game.
   * @param {string[][]} newRevealedBoard - a 2D array of strings representing the current state of the
   * game board, where each string represents the value of a cell on the board.
   * @param setGameOver - setGameOver is a function that takes a boolean value as an argument and updates
   * the state of a variable called gameOver. It is a React hook that is used to manage the game state
   * and determine when the game is over.
   */
  let displayWinningMessage = (newRevealedBoard: string[][]) => {
    if (newRevealedBoard.every((row) => row.every((cell) => cell !== ""))) {
      setGameOver(true);

      // display a message
      let message = document.getElementById("gameOver");
      message!.innerHTML = "Click pengu to play again!";
    }
  };

  /**
   * The function resets the game by setting various variables and displaying a message.
   */
  function resetGame(): void {
    setGameOver(false);
    setPreviousCell({ value: "", row: -1, col: -1 });

    setrevealedBoard([
      ["", "", "", ""],
      ["", "", "", ""],
    ]);

    let message = document.getElementById("gameOver");
    message!.innerHTML = "Match the tiles!!";
  }

  useEffect(() => {
    const eyesFollow = (e: MouseEvent) => {
      let mouseX = e.clientX;
      let mouseY = e.clientY;

      const anchor = document.getElementById("anchor");
      const rekt = anchor!.getBoundingClientRect();
      const anchorX = rekt.left + rekt.width / 2;
      const anchorY = rekt.top + rekt.height / 2;
      const eyes = document.querySelectorAll<HTMLElement>(".eye");

      const angleDeg = angle(anchorX, anchorY, mouseX, mouseY);

      eyes.forEach((eye) => {
        eye.style.transform = `rotate(${160 + angleDeg}deg)`;
      });
    };
    window.addEventListener("mousemove", eyesFollow);

    return () => {
      window.removeEventListener("mousemove", eyesFollow);
    };
  }, []);

  let angle = (cx: number, cy: number, ex: number, ey: number) => {
    const dy = ey - cy;
    const dx = ex - cx;
    const rad = Math.atan2(dy, dx);
    const degree = rad * (180 / Math.PI) + 90;
    return degree;
  };

  return (
    <div className="showGame">
      <div
        className="gameDescription"
        style={{
          minWidth: props.view === "-vertical" ? "400px" : "600px",
        }}
      >
        <p id="gameOver">
          {!showGame ? "Click pengu to play!" : "Match the tiles!!"}
        </p>
        <div
          id="anchor"
          className="container"
          style={{ position: "relative" }}
          onClick={gameOver ? resetGame : handleShowingGame}
        >
          <img className="pengu" src="imgs/pengNoEyes.webp" alt="cool pengu" />
          <img className="left-eye eye" src="imgs/eyemed.webp" alt="eye" />
          <img className="right-eye eye" src="imgs/eyemed.webp" alt="eye" />
        </div>
      </div>

      <div
        className="BoardGame"
        style={{
          animation: "fadeGameOut 1.5s forwards",
          marginTop: props.view === "-vertical" ? "55px" : "0px",
        }}
      >
        {revealedBoard.map((row, i) => (
          <div className={"BoardGame" + props.view} key={i}>
            {row.map((cell, j) => (
              <div
                className="cellContainer"
                key={j}
                style={{
                  cursor: cell === "" ? "pointer" : "not-allowed",
                }}
              >
                <div
                  className="cell"
                  onClick={() => handleCellClick(i, j)}
                  style={{
                    pointerEvents: cell !== "" ? "none" : "auto",
                    opacity: cell === "" ? 1 : 0.55,
                  }}
                >
                  <p
                    style={{
                      opacity: cell === "" ? 0 : 1,
                    }}
                  >
                    {cell}
                  </p>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div
        style={{
          animation: gameOver ? "fadeIn 1s forwards" : "fadeOut 1s forwards",
          margin: "0 auto",
          position: "relative",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          textAlign: "center",
          color: "white",
          fontSize: "2rem",
        }}
      >
        <p style={{ margin: "0" }}>Ayee you win :D</p>
      </div>
    </div>
  );
}
